import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuthStore } from '@/store/auth';

export function useDeploymentMenuAccess() {
  const user = useAuthStore(s => s.user);
  const site = ['building_admin', 'charger_owner', 'property_manager'].includes(user?.template ?? '');
  const query = useQuery({ queryKey: ['deployment-menu-access', user?._id], enabled: !!user && site && !user.facilities_only,
    queryFn: async () => (await api.get('commissioning/menu-access').json<{ data: { assigned: boolean } }>()).data.assigned,
    staleTime: 30_000 });
  return !site || query.data === true;
}
